import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import ResendCodeButton from './ResendCodeButton';

const ResendCodeButtonPicker = ({ onboardingStepResource, ...rest }) => {
  return pickFunction(onboardingStepResource, {
    [fr.relationships.resendCode.name]: () => {
      return (
        <ResendCodeButton
          onboardingStepResource={onboardingStepResource}
          {...rest}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default ResendCodeButtonPicker;
